import { render, staticRenderFns } from "./CobManagerCustomerAdd.vue?vue&type=template&id=fd3f7718&"
import script from "./CobManagerCustomerAdd.vue?vue&type=script&lang=js&"
export * from "./CobManagerCustomerAdd.vue?vue&type=script&lang=js&"
import style0 from "./CobManagerCustomerAdd.vue?vue&type=style&index=0&id=fd3f7718&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports